import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title:
    "End-to-end order visibility, \nwith visualization of the order\nprovisioning from activation \nthrough to completion",
  subtitle: "Business Operations Demo",
  text: "Reduce OPEX costs due to seamless and \nreal-time E2E order visibility.",
  label: { iconPath: "start.png", text: "EPV" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_113"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_111"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 9_R1.mp4",
  pageNumber: "ILO_112",
};

export default DATA_BO_DEMO_ILO1;
